export default __webpack_public_path__ + "static/media/IBMFolderAdd.a118b108.svg";